import styled from 'styled-components';

/* eslint-disable import/prefer-default-export */
export const Square = styled.div<{ backgroundColor?: string }>`
  height: 14px;
  width: 14px;
  background-color: ${({ backgroundColor, theme }) => backgroundColor || theme.colors.black};
  border-radius: 3px;
`;
